import { BLOG_CATEGORIES_DEFAULT_COLOR } from '@constants/params';
import { addTrailingSlash, getDate } from '@libs';
import { SUPPORT_LANGS } from '@constants/langs';
import { normalizeAndClearText } from './text-page';

const DATE_AFTER_RELEASE_NEW_PAGE = '2020-06-03';

export const normalizeBlogNavigation = (tags = []) => {
  if (!tags) {
    return [];
  }

  return tags.map(({ alias, name }) => {
    const category = alias;

    return {
      name,
      category,
    };
  });
};

export const normalizeBlogArticles = (items = []) => {
  if (!items) {
    return [];
  }

  return items.map((item) => {
    const { id, tag, address, description, cover } = item;
    const url = address ? address : id;
    const defaultColor = BLOG_CATEGORIES_DEFAULT_COLOR[tag];

    return {
      id,
      description,
      url,
      defaultColor,
      cover,
      gradientColor: item.color,
      title: item.caption,
      category: item.tag,
      categoryName: item.tag_name,
    };
  });
};

export const normalizeBlog = (data) => {
  const { tags = [], pageCount = 0, items = [] } = data || {};
  const navigations = normalizeBlogNavigation(tags);
  const articles = normalizeBlogArticles(items, navigations);

  return { articles, navigations, pageCount };
};

export const normalizeBlogPage = (data = {}, { locale }) => {
  if (!data) {
    return {};
  }

  const { item = {} } = data;
  const { id, publication_date, description, body } = item;
  const date = getDate(publication_date, locale);
  const isOldPage = new Date(DATE_AFTER_RELEASE_NEW_PAGE) >= new Date(publication_date * 1000);

  return {
    id,
    description,
    body: normalizeAndClearText(body),
    date,
    isOldPage,
    title: item.caption,
    category: item.tag,
    categoryName: item.tag_name,
    countViews: item.count_views,
  };
};

export const normalizeBlogPopular = (data) => {
  const { tags = [], items = [] } = data || {};
  const navigations = normalizeBlogNavigation(tags);
  const articles = normalizeBlogArticles(items, navigations);

  return articles.slice(0, 5);
};

export const normalizeBlogAlternateLinks = (data = {}) => {
  if (!data) {
    return [];
  }

  const { item = {} } = data;
  const links = item.alternate_links || {};

  return SUPPORT_LANGS.reduce((acc, lang) => {
    if (lang.hrefLang in links) {
      // TODO заменить 'getblog' на бэке?
      const href = links[lang.hrefLang].replace('getblog', 'blog');

      // Проверяем, есть ли точки в последней части урла. Если есть, next воспринимает урл как путь к файлу и
      // убирает trailing slash, поэтому мы должны тоже убрать эти слеши из альтернативных ссылок
      const hrefWithoutParams = href.split('?')[0].replace(/\/?(\?|#|$)/, '');
      const pathname = hrefWithoutParams.split('/').pop();
      const urlHasDots = ~pathname.indexOf('.');

      acc.push({
        href: addTrailingSlash(href, urlHasDots),
        hrefLang: lang.hrefLang,
      });
    }

    return acc;
  }, []);
};
